import {
  requestDownloadCert,
  requestUploadCert,
} from "../requests/trustManagerRequest";
import { call, put } from "@redux-saga/core/effects";
import { setTrustHolders, setTrusts } from "../../reducers/trustManagerReducer";
import confirmSaga from "./modalSagas";
import { toast } from "react-toastify";
import { handleError } from "../../../util/errorHandler";
import { TrustControllerApi } from "../../../generated/api";
import { getAPIConfig } from "../../../util/api-config";
import store from "../../configureStore";
import i18n from "../../../i18n/i18n";

function handleSuccess(message: String) {
  toast.info(message);
}

function setUpClient() {
  return new TrustControllerApi(
    getAPIConfig(store.getState().settings.internalSettings)
  );
}

export function* handleGetTrustHolders(): any {
  try {
    const TrustClient = setUpClient();
    const response = yield TrustClient.listTrustHolders();
    yield put(setTrustHolders(response));
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleAddTrustHolder(action: any): any {
  try {
    const TrustClient = setUpClient();
    yield TrustClient.addTrustHolder(action.trustHolderDto);
    yield put({ type: "GET_TRUST_HOLDERS" });
    toast.success(String(i18n.t("toasts.trustAdded")));
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleGetTrusts(): any {
  try {
    const TrustClient = setUpClient();
    const response = yield TrustClient.listTrusts();
    yield put(setTrusts(response));
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleAddCa(action: any): any {
  try {
    console.log(action);
    const response = yield call(requestUploadCert, action.params);
    if (response.status === 200) {
      yield put({ type: "GET_TRUSTS" });
    toast.success(String(i18n.t("toasts.certificateAdded")));
    }
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleDeleteCa(action: any): any {
  try {
    const TrustClient = setUpClient();
    yield TrustClient.deleteCA(action.params);
    yield put({ type: "GET_TRUSTS" });
    toast.success(String(i18n.t("toasts.certificateDeleted")));
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleDeleteTrustHolder(action: any): any {
  try {
    const TrustClient = setUpClient();
    const response = yield TrustClient.deleteTrustHolder(action.params);
    if (response.status === 200) {
      yield put({ type: "GET_TRUST_HOLDERS" });
    toast.success(String(i18n.t("toasts.trustDeleted")));
    }
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleDeleteCaModal(action: any): any {
  try {
    const isConfirmed = yield call(confirmSaga, "delete");
    if (isConfirmed) {
      yield call(handleDeleteCa, action);
    }
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleDeleteTrustHolderModal(action: any): any {
  try {
    const isConfirmed = yield call(confirmSaga, "delete");
    if (isConfirmed) {
      yield call(handleDeleteTrustHolder, action);
    }
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleDownloadCa(action: any): any {
  try {
    const FileSaver = require("file-saver");
    const response = yield call(requestDownloadCert, action.params);

    const [, fileName] =
      response.headers["content-disposition"].split("filename=");
    FileSaver.saveAs(new Blob([response.data]), fileName);
  } catch (error: any) {
    yield handleError(error);
  }
}
